module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/childModal/childModal.component.css
// module id = ./src/app/shared/components/childModal/childModal.component.css
// module chunks = main